module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/icon-calendar-lg-9825e05424f194f5867bbd5efc8ef737.png";